import { App as AntApp, ConfigProvider, theme } from "antd";
import { BrowserRouter } from "react-router-dom";
import { SocketProvider } from "./contexts/SocketContext";
import { ThemeProvider, useTheme } from "./contexts/ThemeContext";
import AppRoutes from "./routes";
import NotificationListener from "./hooks/useSocketInit";
import useAuthInit from "./hooks/useAuthInit";
import InitProgressBar from "./components/common/InitProgressBar";

const AppContent = () => {
  const { theme: appTheme } = useTheme();

  return (
    <ConfigProvider
      theme={{
        algorithm:
          appTheme === "dark" ? theme.darkAlgorithm : theme.defaultAlgorithm,
      }}
    >
      <AntApp>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <NotificationListener />
      </AntApp>
    </ConfigProvider>
  );
};
function App() {
  useAuthInit();
  return (
    <>
      <InitProgressBar />
      <ThemeProvider>
        <SocketProvider>
          <AppContent />
        </SocketProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
